<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { createBubbler, stopPropagation } from 'svelte/legacy'

	const bubble = createBubbler()

	interface Props {
		checked?: boolean
		required?: boolean
		name?: string
		label?: string
		small?: boolean
		smallText?: boolean
		full?: boolean
		loading?: boolean
		id?: string
		indeterminate?: boolean
		showAsterisk?: boolean
		hideLabel?: boolean
		nativeEvent?: boolean
		disabled?: boolean
		class?: string | null
		children?: import('svelte').Snippet
	}

	let {
		checked = $bindable(null),
		required = false,
		name = '',
		label = '',
		small = false,
		smallText = false,
		full = false,
		loading = false,
		id = null,
		indeterminate = false,
		showAsterisk = false,
		hideLabel = false,
		nativeEvent = false,
		disabled = false,
		class: className = null,
		children,
	}: Props = $props()

	const dispatch = createEventDispatcher()

	function handleChange(event: Event) {
		if (nativeEvent) {
			dispatch('change', event)
		} else {
			dispatch('change', checked)
		}
	}
</script>

<label
	class="
    {full ? 'flex w-full' : 'inline-flex'}
    {disabled ? 'opacity-60' : 'cursor-pointer'}
    items-center text-base whitespace-nowrap {className}
  "
	class:text-xs={smallText}
>
	<input
		{id}
		{name}
		class="
      form-checkbox
      text-primary-500
      appearance-none
      {hideLabel ? '' : small ? 'mr-3' : 'mr-4'}
      {small
			? 'h-5 w-5'
			: 'h-7 w-7'} focus-visible:ring-primary-600 rounded border border-gray-400 bg-transparent focus:ring-transparent focus-visible:ring-2
      {disabled
			? ''
			: 'hover:bg-primary-500/10 hover:border-primary-500 checked:hover:bg-primary-400 checked:bg-primary-500 cursor-pointer checked:border-transparent hover:border-2'}
    "
		class:animate-pulse={loading}
		aria-label={hideLabel ? label : null}
		{disabled}
		{indeterminate}
		onchange={handleChange}
		onclick={stopPropagation(bubble('click'))}
		{required}
		type="checkbox"
		bind:checked
	/>
	{#if label && !hideLabel}
		{label}
	{:else}
		{@render children?.()}
	{/if}
	{#if showAsterisk && required}
		<span class="mr-1 text-red-500">*</span>
	{/if}
</label>
